import React from 'react';
import {connect} from 'react-redux';
import {dropdownBoundariesOpen, toggleBoundary} from '../actions';
import Combo from '../components/Combo';
import './Navigator.css';

class BoundaryNavigator extends React.Component {
  handleToggle = () => {
    const { dispatch, list_open } = this.props;
    dispatch(dropdownBoundariesOpen(!list_open));
  };

  render() {
    const { dispatch, boundaries, list_open } = this.props;

    return (
      <Combo open={list_open} label="Boundaries" onClick={this.handleToggle}>
        {
          boundaries.map((value, i) => (
            <div className="c-navigator__option" key={i}>
              <input className="c-navigator__input"
                     type="checkbox" checked={value.active}
                     onChange={() => {
                     }}
                     id={'layer-toggle-' + i}/>
              <label className="c-navigator__label" htmlFor={'layer-toggle-' + i}
                     onClick={() => dispatch(toggleBoundary(value.prefix))}>
                {value.displayName}
                {value.type === 'wms' &&
                 <img
                   src={value.source +
                        'REQUEST=GetLegendGraphic&format=image/png&transparent=true&layer=' +
                        value.params.layers}
                   className="c-navigator__legend" id={'layer-navigator-legend-' + i} alt=""/>
                }
                {value.type === 'geojson' &&
                 <div
                   className="c-navigator__legend c-navigator__legend_geojson-border"
                   id={'layer-navigator-legend-' + i}
                   style={{
                     borderStyle: (value.style.dashArray ? 'dashed' : 'solid'),
                     borderColor: value.style.color
                   }}/>
                }
              </label>
            </div>
          ))
        }
      </Combo>
    );
  }
}

const mapStateToProps = state => {
  return {
    boundaries: state.boundaries.layers,
    list_open: state.view.boundaries_list_open
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BoundaryNavigator);



// WEBPACK FOOTER //
// ./src/containers/BoundaryNavigator.js